import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { Checkbox } from 'primeng/checkbox';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface ToggleFieldProps extends FormlyFieldProps {
  undefinedFalseValue?: boolean;
}

@Component({
  selector: 'toggle-field',
  standalone: true,
  imports: [...FORM_IMPORTS, Checkbox],
  template: `
    <p-checkbox
      [formControl]="formControl"
      [formlyAttributes]="field"
      [binary]="true"
      [falseValue]="props.undefinedFalseValue ? undefined : false"
    />
  `,
})
export class CheckboxFieldType extends FieldType<
  FieldTypeConfig<ToggleFieldProps>
> {}
